<template>
  <div>
    <h4>Links</h4>
    <u-loader v-if="isLoading" />
    <table
      v-else
      class="w-100 linksTable ml-2 mt-4"
    >
      <thead>
        <tr>
          <th>Priorität</th>
          <th>Sprachen</th>
          <th>Beschreibung</th>
          <th>Link</th>
          <th>Aktionen</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(link, index) in allLinks">
          <!-- Row 1 -->
          <tr
            :key="index"
            style="border-bottom: 1px solid #ddd"
          >
            <td v-if="currentEditRow != index">
              {{ link.weight }}
            </td>
            <td v-else>
              <v-text-field
                v-model="link.weight"
                type="number"
                class="mr-4 normalFontSize"
              />
              <u-validation-checker
                v-model="requiredPropertiesEdit"
                :is-empty="!link.weight.toString()"
                :section="validationSection"
                property-name="weight"
              />
            </td>
            <td v-if="currentEditRow != index">
              <div
                v-for="(language, languageIndex) in allLanguages"
                :key="languageIndex"
              >
                <div
                  v-if="
                    link.contents.filter((content) => {
                      return content.language == language.value;
                    }).length != 0
                  "
                >
                  {{ language.name }}
                </div>
              </div>
            </td>
            <td v-else>
              <label>
                <input
                  type="checkbox"
                  name="check"
                  :checked="currentEditRowLanguages.indexOf('de-CH') != -1"
                  @change="languageCheckBoxChanged('de-CH', true)"
                >
                <span class="label-text">Deutsch</span>
              </label>
              <br>
              <label>
                <input
                  type="checkbox"
                  name="check"
                  :checked="currentEditRowLanguages.indexOf('fr-CH') != -1"
                  @change="languageCheckBoxChanged('fr-CH', true)"
                >
                <span class="label-text">Französisch</span>
              </label>
              <br>
              <label>
                <input
                  type="checkbox"
                  name="check"
                  :checked="currentEditRowLanguages.indexOf('it-CH') != -1"
                  @change="languageCheckBoxChanged('it-CH', true)"
                >
                <span class="label-text">Italienisch</span>
              </label>

              <u-validation-checker
                v-model="requiredPropertiesEdit"
                :is-empty="currentEditRowLanguages.length == 0"
                :section="validationSection"
                property-name="content.language"
              />
            </td>
            <td v-if="currentEditRow != index">
              {{ link.contents.length != 0 ? link.contents[0].value : "" }}
            </td>
            <td v-else>
              <div
                v-for="(language, languageIndex) in allLanguages"
                :key="languageIndex"
              >
                <v-text-field
                  v-if="
                    link.contents.filter((content) => {
                      return content.language == language.value;
                    }).length != 0
                  "
                  v-model="
                    link.contents.filter((content) => {
                      return content.language == language.value;
                    })[0].value
                  "
                  type="text"
                  multi-line
                  rows="1"
                  auto-grow
                  :placeholder="'Beschreibung ' + language.name"
                  :label="language.name"
                  class="mr-4 normalFontSize"
                />
              </div>
              <u-validation-checker
                v-model="requiredPropertiesEdit"
                :is-empty="
                  link.contents.filter((content) => {
                    return content.value == '';
                  }).length != 0
                "
                :section="validationSection"
                property-name="content.value"
              />
            </td>
            <td v-if="currentEditRow != index">
              <!-- not using router link here because we want to open the link in a new window -->
              <div
                v-for="(language, languageIndex) in allLanguages"
                :key="languageIndex"
              >
                <div
                  v-if="
                    link.contents.filter((content) => {
                      return content.language == language.value;
                    }).length != 0
                  "
                >
                  <b>{{ language.name }}: </b>
                  <a
                    class="ellipsisOverflow"
                    :href="
                      link.contents.filter((content) => {
                        return content.language == language.value;
                      })[0].url
                    "
                    :title="
                      link.contents.filter((content) => {
                        return content.language == language.value;
                      })[0].value
                    "
                  >{{
                    link.contents.filter((content) => {
                      return content.language == language.value;
                    })[0].value
                  }}</a>
                </div>
              </div>
            </td>
            <td v-else>
              <div
                v-for="(language, languageIndex) in allLanguages"
                :key="languageIndex"
              >
                <v-text-field
                  v-if="
                    link.contents.filter((content) => {
                      return content.language == language.value;
                    }).length != 0
                  "
                  v-model="
                    link.contents.filter((content) => {
                      return content.language == language.value;
                    })[0].url
                  "
                  type="text"
                  multi-line
                  rows="1"
                  auto-grow
                  :placeholder="'Link ' + language.name"
                  :label="language.name"
                  class="mr-4 normalFontSize"
                />
              </div>
              <u-validation-checker
                v-model="requiredPropertiesEdit"
                :is-empty="
                  link.contents.filter((content) => {
                    return content.url == '';
                  }).length != 0
                "
                :section="validationSection"
                property-name="content.url"
              />
            </td>
            <td v-if="currentEditRow != index">
              <div>
                <button
                  v-if="canUserEdit"
                  v-b-tooltip.hover
                  type="button"
                  placement="bottom"
                  title="Link bearbeiten"
                  class="btn btn-primary smallActionButton"
                  @click="
                    resetLinkData();
                    ((currentEditRow = index),
                    setCurrentLanguages(link.contents));
                  "
                >
                  <i class="fas fa-edit" />
                </button>

                <button
                  v-if="canUserEdit"
                  v-b-modal.deleteLink
                  v-b-tooltip.hover
                  type="button"
                  placement="bottom"
                  title="Link löschen"
                  class="btn btn-danger smallActionButton ml-2"
                  @click="currentModalLink = index"
                >
                  <i class="fas fa-trash-alt" />
                </button>
              </div>
            </td>
            <td v-else>
              <button
                v-b-tooltip.hover
                type="button"
                placement="bottom"
                title="Speichern"
                class="btn btn-success smallActionButton"
                :disabled="requiredPropertiesEdit.length != 0"
                @click="saveLink()"
              >
                <i class="fas fa-check" />
              </button>

              <button
                v-b-tooltip.hover
                type="button"
                placement="bottom"
                title="Abbrechen"
                class="btn btn-danger smallActionButton ml-2"
                @click="
                  resetLinkData();
                  cancelEdit(index);
                "
              >
                <i class="fas fa-times" />
              </button>
            </td>
          </tr>
          <!-- Row 2 -->
          <tr :key="'ROW2_' + index">
            <td />
            <td
              v-if="currentEditRow != index"
              colspan="2"
            >
              <div>
                <b class="inline-block">Verwendung </b>
                <div>
                  <span
                    v-for="(
                      selectedItem, selectedItemIndex
                    ) in dropDownListUsedFor_selectedItems[index]"
                    :key="selectedItem.id"
                  >
                    {{ selectedItem.description }}

                    <span
                      v-if="
                        selectedItemIndex + 1 !=
                          dropDownListUsedFor_selectedItems[index].length
                      "
                    >,
                    </span>
                  </span>
                </div>
              </div>
            </td>
            <td
              v-else
              v-show="!isUpdating"
              v-b-tooltip.hover
              colspan="2"
              class="mb-2"
              placement="bottom"
              title="Anlage wird nur ersetzt wenn eine Datei ausgewählt ist. Sonst werden beim Speichern nur die Priorität und die Beschreibung überschrieben."
            >
              <div>
                <b class="inline-block">Verwendung</b>
                <v-select
                  v-model="dropDownListUsedFor_selectedItems[currentEditRow]"
                  :items="dropDownListUsedFor[currentEditRow]"
                  item-text="description"
                  item-value="id"
                  return-object
                  multiple
                  @change="
                    updateDropDownList(
                      dropDownListUsedFor[currentEditRow],
                      dropDownListUsedFor_selectedItems[currentEditRow],
                      currentEditRow,
                    )
                  "
                />
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </table>

    <u-error-handling
      v-if="errorObject"
      class="mt-4"
      :error-object="errorObject"
      :property-mapping="errorPropertyMappings"
    />
    <b-modal
      id="deleteLink"
      ref="deleteLink"
      hide-footer
      title="Anlage löschen"
      no-fade
    >
      <div class="d-block mb-4">
        Sind Sie sicher, dass Sie diesen Link löschen möchten?
      </div>
      <b-button
        variant="success"
        @click="deleteLink()"
      >
        Ok
      </b-button>
      <b-button
        class="ml-2"
        variant
        @click="hideModal"
      >
        Abbrechen
      </b-button>
    </b-modal>

    <div
      v-if="!addLink"
      class="w-100 mt-4"
      style="text-align: right"
    >
      <span>
        <button
          v-if="canUserEdit"
          v-b-tooltip.hover
          type="button"
          placement="bottom"
          title="Link hinzufügen"
          class="btn btn-success"
          @click="addLink = true"
        >
          <i class="fas fa-plus" />
        </button>
      </span>
    </div>
    <div v-else>
      <h5 class="mt-4 mb-4">
        Link hinzufügen
      </h5>
      <form
        class="ml-2"
        @submit.prevent="addNewLink"
      >
        <div class="form-group">
          <b-container class="pb-0 pt-0">
            <b-row>
              <label
                for="filter"
                class="pl-0 col-2"
              >Priorität</label>
              <div class="col-9 pl-0">
                <v-flex sm6>
                  <v-text-field
                    v-model="newLink.weight"
                    type="number"
                    label="Priorität"
                    class="mr-4 normalFontSize"
                  />
                </v-flex>
                <u-validation-checker
                  v-model="requiredPropertiesNew"
                  :is-empty="!newLink.weight"
                  :section="validationSection"
                  property-name="weight"
                />
              </div>
            </b-row>
          </b-container>
        </div>
        <div class="form-group">
          <b-container class="pb-0 pt-0">
            <b-row>
              <label
                for="filter"
                class="pl-0 col-2"
              >Sprachen</label>
              <div class="col-9 pl-0">
                <label>
                  <input
                    type="checkbox"
                    name="check"
                    :checked="newLinkLanguages.indexOf('de-CH') != -1"
                    @change="languageCheckBoxChanged('de-CH', false)"
                  >
                  <span class="label-text">Deutsch</span>
                </label>
                <br>
                <label>
                  <input
                    type="checkbox"
                    name="check"
                    :checked="newLinkLanguages.indexOf('fr-CH') != -1"
                    @change="languageCheckBoxChanged('fr-CH', false)"
                  >
                  <span class="label-text">Französisch</span>
                </label>
                <br>
                <label>
                  <input
                    type="checkbox"
                    name="check"
                    :checked="newLinkLanguages.indexOf('it-CH') != -1"
                    @change="languageCheckBoxChanged('it-CH', false)"
                  >
                  <span class="label-text">Italienisch</span>
                </label>
                <u-validation-checker
                  v-model="requiredPropertiesNew"
                  :is-empty="newLinkLanguages.length == 0"
                  :section="validationSection"
                  property-name="content.language"
                />
              </div>
            </b-row>
          </b-container>
        </div>
        <div class="form-group">
          <b-container class="pb-0 pt-0">
            <b-row>
              <label
                for="filter"
                class="pl-0 col-2"
              >Beschreibung</label>
              <div class="col-9 pl-0">
                <div
                  v-for="(language, languageIndex) in allLanguages"
                  :key="languageIndex"
                >
                  <v-text-field
                    v-if="newLinkLanguages.indexOf(language.value) != -1"
                    v-model="
                      newLink.contents.filter((content) => {
                        return content.language == language.value;
                      })[0].value
                    "
                    type="text"
                    multi-line
                    rows="1"
                    auto-grow
                    :placeholder="'Beschreibung ' + language.name"
                    :label="language.name"
                    class="mr-4 normalFontSize"
                  />
                </div>
                <u-validation-checker
                  v-model="requiredPropertiesNew"
                  :is-empty="
                    newLink.contents.filter((content) => {
                      return content.value == '';
                    }).length != 0
                  "
                  :section="validationSection"
                  property-name="content.value"
                />
              </div>
            </b-row>
          </b-container>
        </div>
        <div class="form-group">
          <b-container class="pb-0 pt-0">
            <b-row>
              <label
                for="filter"
                class="pl-0 col-2"
              >Verwendung</label>

              <div class="col-9 pl-0">
                <v-select
                  v-model="dropDownListDetails_selectedItems_new"
                  :items="dropDownListDetails_new"
                  item-text="description"
                  multiple
                  item-value="id"
                  return-object
                  @change="
                    updateDropDownList(
                      dropDownListDetails_new,
                      dropDownListDetails_selectedItems_new,
                    )
                  "
                />
              </div>
            </b-row>
          </b-container>
        </div>
        <div class="form-group">
          <b-container class="pb-0 pt-0">
            <b-row>
              <label
                for="filter"
                class="pl-0 col-2"
              >URL</label>
              <div class="col-9 pl-0">
                <div
                  v-for="(language, languageIndex) in allLanguages"
                  :key="languageIndex"
                >
                  <v-text-field
                    v-if="newLinkLanguages.indexOf(language.value) != -1"
                    v-model="
                      newLink.contents.filter((content) => {
                        return content.language == language.value;
                      })[0].url
                    "
                    type="text"
                    multi-line
                    rows="1"
                    auto-grow
                    :placeholder="'Link ' + language.name"
                    :label="language.name"
                    class="mr-4 normalFontSize"
                  />
                </div>
                <u-validation-checker
                  v-model="requiredPropertiesNew"
                  :is-empty="
                    newLink.contents.filter((content) => {
                      return content.url == '';
                    }).length != 0
                  "
                  :section="validationSection"
                  property-name="content.url"
                />
              </div>
            </b-row>
          </b-container>
        </div>
        <b-btn
          variant="success"
          type="submit"
          :disabled="requiredPropertiesNew.length != 0"
        >
          Hinzufügen
        </b-btn>
        <b-btn
          variant="danger"
          class="ml-2"
          @click="cancelAddLink"
        >
          Abbrechen
        </b-btn>
      </form>
    </div>
  </div>
</template>

<script>
import {
  GetLinks,
  AddLink,
  UpdateLink,
  DeleteLink,
  GetDropdownList,
} from "@/services/contract.edition.links.service.js";

export default {
  props: {
    contractId: {
      type: String,
      default: "",
    },
    versionId: {
      type: Number,
      default: 0,
    },
    editionId: {
      type: Number,
      default: 0,
    },
    canUserEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      validationSection: "Links",
      allLinks: [],
      allOriginalLinks: [],
      isLoading: false,
      errorObject: null,
      addLink: false,
      currentEditRow: -1,
      currentEditRowLanguages: [],
      currentModalLink: -1,
      newLink: {
        id: 0,
        contents: [
          {
            id: 0,
            value: "",
            language: "de-CH",
            url: "",
            linkId: 0,
            valid: true,
            validated: "",
            statusMessage: "",
          },
        ],
        dropDownListUsedFor: {},
        weight: "0",
        archived: false,
        editionId: this.editionId,
        code: "newLink",
        contentSortingOrder: 0,
        order: 0,
      },
      errorPropertyMappings: [],
      newLinkLanguages: ["de-CH"],
      allLanguages: [
        { name: "Deutsch", value: "de-CH" },
        { name: "Französisch", value: "fr-CH" },
        { name: "Italienisch", value: "it-CH" },
      ],
      requiredPropertiesEdit: [],
      requiredPropertiesNew: [],
      dropDownListDetails_selectedItems_new: [],
      dropDownListDetails_new: [],
      dropDownListUsedFor: [],
      dropDownListUsedFor_selectedItems: [],
    };
  },
  created() {
    this.loadLinks();
  },
  methods: {
    createErrorPropertyMappings() {
      var mapping = {};
      var index = 0;

      var languageArray = this.addLink
        ? this.newLinkLanguages
        : this.currentEditRowLanguages;

      languageArray.map((linkLanguage) => {
        var language = this.allLanguages.filter((language) => {
          return language.value == linkLanguage;
        });

        mapping[`Contents[${index}].Url`] = `${language[0].name} URL`;
        mapping[`Contents[${index}].Value`] =
          `${language[0].name} Beschreibung`;

        index++;
      });

      return mapping;
    },
    loadLinks() {
      this.dropDownListUsedFor_selectedItems = [];
      this.loadDropdowns();
      this.isLoading = true;
      this.errorObject = null;

      GetLinks(
        this.contractId,
        this.versionId,
        this.editionId,
        (response) => {
          this.setDropDownListUsedFor(response);
          this.isLoading = false;
          this.allLinks = response;
          this.allOriginalLinks = JSON.parse(JSON.stringify(response));
        },
        (error) => {
          this.loadingError = true;
          this.errorObject = error;
        },
      );
    },
    loadDropdowns() {
      GetDropdownList(
        (response) => {
          this.dropDownListDetails_new = response.dropDownListDetails;
          this.dropDownListDetails_selectedItems_new = this.setDropDownList(
            response.dropDownListDetails,
          );
          this.newLink.dropDownListUsedFor = response;
        },
        (error) => {
          false;
          this.loadingError = true;
          this.errorObject = error;
        },
      );
    },

    updateDropDownList(
      dropDownListDetails,
      dropDownListDetails_selectedItems,
      currentEditRow,
    ) {
      if (dropDownListDetails_selectedItems) {
        let itemsProcessed = 0;
        dropDownListDetails.forEach((dropDownListDetail, index) => {
          const findItem = dropDownListDetails_selectedItems.find(
            (dropDownListUsedFor_selectedItem) =>
              dropDownListUsedFor_selectedItem.dropDownListId ==
                dropDownListDetail.dropDownListId &&
              dropDownListUsedFor_selectedItem.description ==
                dropDownListDetail.description,
          );
          if (findItem) {
            dropDownListDetails[index].selected = true;
          } else {
            dropDownListDetails[index].selected = false;
          }

          itemsProcessed++;
        });
        if (
          itemsProcessed == dropDownListDetails.length &&
          currentEditRow != null
        ) {
          this.allLinks[
            currentEditRow
          ].dropDownListUsedFor.dropDownListDetails = dropDownListDetails;
        }
      }
    },

    setDropDownListUsedFor(allDataEnteries) {
      allDataEnteries.forEach((entry) => {
        const selectedListItems = [];
        this.dropDownListUsedFor.push(
          entry.dropDownListUsedFor.dropDownListDetails,
        );

        entry.dropDownListUsedFor.dropDownListDetails.forEach(
          (dropDownListDetail) => {
            if (dropDownListDetail.selected == true) {
              selectedListItems.push(dropDownListDetail);
            }
          },
        );
        this.dropDownListUsedFor_selectedItems.push(selectedListItems);
      });
    },
    setDropDownList(dropDownListDetails) {
      let dropDownListDetails_selectedItems = [];
      let arrayPos = 0;
      dropDownListDetails.forEach((dropDownListDetail) => {
        if (dropDownListDetail.selected) {
          dropDownListDetails_selectedItems.push(dropDownListDetail);
        }
        arrayPos++;
      });
      if (arrayPos == dropDownListDetails.length) {
        return dropDownListDetails_selectedItems;
      }
    },

    languageCheckBoxChanged(language, isEditLanguage) {
      var languages;
      var link;

      if (isEditLanguage) {
        languages = this.currentEditRowLanguages;
        link = this.allLinks[this.currentEditRow];
      } else {
        languages = this.newLinkLanguages;
        link = this.newLink;
      }

      if (languages.indexOf(language) == -1) {
        languages.push(language);

        // add a new langauge Content to
        link.contents.push({
          id: 0,
          value: "",
          language: language,
          url: "",
          linkId: link.id,
          valid: true,
          validated: "",
          statusMessage: "",
        });
      } else {
        languages.splice(languages.indexOf(language), 1);
        var languageContentToRemove = link.contents.filter((content) => {
          return content.language == language;
        });
        if (languageContentToRemove) {
          link.contents.splice(
            link.contents.indexOf(
              link.contents.filter((content) => {
                return content.language == language;
              })[0],
            ),
            1,
          );
        }
      }
    },
    addNewLink() {
      this.errorObject = null;
      this.errorPropertyMappings = this.createErrorPropertyMappings();

      AddLink(
        this.contractId,
        this.versionId,
        this.editionId,
        this.newLink,
        () => {
          this.loadLinks();
          this.cancelAddLink();
        },
        (error) => {
          this.errorObject = error;
        },
      );
    },
    setCurrentLanguages(contents) {
      this.currentEditRowLanguages = [];
      contents.map((content) => {
        this.currentEditRowLanguages.push(content.language);
      });
    },
    cancelEdit() {
      this.currentEditRow = -1;
      this.currentEditRowLanguages = [];
      this.requiredPropertiesEdit = [];
    },
    cancelAddLink() {
      this.errorObject = null;
      this.requiredPropertiesNew = [];
      this.addLink = false;
      this.newLinkLanguages = ["de-CH"];
      this.newLink = {
        id: 0,
        contents: [
          {
            id: 0,
            value: "",
            language: "de-CH",
            url: "",
            linkId: 0,
            valid: true,
            validated: "",
            statusMessage: "",
          },
        ],
        weight: "0",
        archived: false,
        editionId: this.editionId,
        code: "newLink",
        contentSortingOrder: 0,
        order: 0,
      };
    },
    hideModal() {
      this.$refs["deleteLink"].hide();
    },
    saveLink() {
      this.errorObject = null;
      this.errorPropertyMappings = this.createErrorPropertyMappings();
      var linkToUpdate = this.allLinks[this.currentEditRow];

      UpdateLink(
        this.contractId,
        this.versionId,
        this.editionId,
        linkToUpdate.id,
        linkToUpdate,
        () => {
          this.loadLinks();
          this.cancelEdit();
        },
        (error) => {
          this.errorObject = error;
        },
      );
    },
    deleteLink() {
      var linkToDelete = this.allLinks[this.currentModalLink];

      DeleteLink(
        this.contractId,
        this.versionId,
        this.editionId,
        linkToDelete.id,
        () => {
          this.hideModal();
          this.loadLinks();
        },
        (error) => {
          this.hideModal();
          this.errorObject = error;
        },
      );
    },
    resetLinkData() {
      this.requiredPropertiesEdit = [];
      this.allLinks = JSON.parse(JSON.stringify(this.allOriginalLinks));
    },
  },
};
</script>

<style scoped>
.smallActionButton {
  width: 25px;
  height: 25px;
  font-size: 17px;
  padding: 0px;
}

.normalFontSize {
  font-size: 1rem;
}
.ellipsisOverflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  margin-right: 10px;
}

.linksTable {
  font-size: small;
  table-layout: fixed;
}

.linksTable tbody tr {
  border-bottom: 4px solid #ddd;
}
.linksTable th {
  padding-right: 30px;
}
.linksTable thead th:nth-child(1) {
  width: 8%;
}
.linksTable thead th:nth-child(2) {
  width: 10%;
}
.linksTable thead th:nth-child(3) {
  width: 30%;
}
.linksTable thead th:nth-child(4) {
  width: 42%;
}
.linksTable tr td:first-child {
  border-bottom: 2px solid white;
}
.linksTable tr td {
  padding-bottom: 10px;
  padding-top: 10px;
  vertical-align: top;
}
.linksTable tr:nth-child(2n) td {
  padding-top: 10px;
}
</style>
